<script>
  import { onMount } from 'svelte'
  import { mileageStore, dataStore } from '../../stores'
  import Loader from '../Loader.svelte'
  import AddMileageModal from './AddMileageModal.svelte'
  import { Datatable } from 'svelte-simple-datatables';
  import { settings } from '../../../scripts/datatablesSettings';
  import { config } from '../../../scripts/defaultURL';
  import EditMileageModal from './EditMileageModal.svelte';
  import { formatDate, openModal } from '../../../scripts/functions';
  import { getData } from '../../../scripts/rest';

  let initialized = false;
  let mileageSelected = false;
  let data;
  let rows;
  let mileageEntry;
  let mileageData;

  $: if ($mileageStore == 'getData') {
    getData(`${config.defaultURL}/mileage`).then((response) => { 
      data = response;
      initialized = true; 
    });
    $mileageStore = '';
  }

  $: if (data) {
    if (!$dataStore) $dataStore = {};
    $dataStore['mileage'] = data;
    console.log('dataStore',$dataStore);
    genDestinations();
  }

  $: if (document.getElementById('editMileageModal') && !document.getElementById('editMileageModal').classList.contains('is-active')) {
    mileageSelected = false;
    mileageEntry = null;
  }

  function genDestinations() {
    const sorted = data.sort((a, b) => {
      const A = a.destination ? a.destination.toUpperCase() : null;
      const B = b.destination ? b.destination.toUpperCase() : null;
      if (A < B) return -1;
      if (B < A) return 1;
      return 0;
    });
    
    mileageData = [];
    sorted.forEach((item) => {
      if (item.destination && mileageData.indexOf(item.destination) == -1) {
        mileageData.push(item.destination);
      }
    });
  }

  onMount(() => {
    getData(`${config.defaultURL}/mileage`).then((response) => { 
      data = response;
      initialized = true; 
    });
  })

  function addMileageModal() {
    document.getElementById('mileageModal').classList.add('is-active')
    initialized = false
  }

  function editMileageModal(item) {
    mileageSelected = true;
    mileageEntry = item;
    console.log('mileage item',mileageEntry);    
    
    openModal('editMileageModal');
  }
</script>

<style>
  /* .table-container {
    overflow-y: auto;
    height: 65vh;
  } */

  td {
    cursor: pointer;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;
  }

</style>

<div class="flex">
  <div class="left">
    <h3>Mileage Log</h3>
  </div>
  <div class="right">
    <button on:click={addMileageModal} class="button is-primary">
      <span class="icon">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" />
        </svg>
      </span>
      <span>Add Mileage</span>
    </button>
  </div>
</div>
{#if data}
<AddMileageModal {mileageData} />
{/if}
{#if initialized}
  <Datatable settings={settings} data={data.sort((a,b) => { return new Date(b.date) - new Date(a.date) })} bind:dataRows={rows}>
    <thead>
      <tr>
        <th data-key="date">Date</th>
        <th data-key="destination">Destination</th>
        <th data-key="mileage">Mileage</th>
      </tr>
    </thead>
    <tbody>
      {#if rows}
      {#each $rows as item}
        <tr id={item.id} on:click={() => { editMileageModal(item) }}>
          <td>{formatDate(item.date)}</td>
          <td>{item.destination}</td>
          <td>{item.mileage}</td>
        </tr>
      {/each}
      {/if}
    </tbody>
  </Datatable>
{:else}
  <!-- Insert loading animation -->
  <Loader />
{/if}

{#if mileageSelected && data}
<EditMileageModal {mileageEntry} mileageData={data} />
{/if}